import React from 'react';
import cns from 'classnames';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import BasicText from '../../../components/formComponents/groups/BasicText';
import BasicSelect from '../../../components/formComponents/groups/BasicSelect';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../components/VerbButton';

const UserInviteList = ({ fields }) => {
    const selectValues = [{ value: 'Coworker', label: 'Coworker' }];

    const pushField = () => {
        fields.push({
            email: '',
            name: '',
            position: ''
        });
    };

    const removeField = (i) => {
        fields.remove(i);
    };

    const fieldsToRender = fields.map((name, i) => (
        <div className={'col-md-12 userInvite'} key={name}>
            <Field
                placeholderTextId={'NAME'}
                placeholderDefault={'Name'}
                className={'col-md-4'}
                name={`${name}.name`}
                component={BasicText}
            />
            <Field
                placeholderTextId={'EMAIL'}
                placeholderDefault={'Email'}
                className={'col-md-4'}
                name={`${name}.email`}
                component={BasicText}
            />
            <Field
                className={'col-md-3'}
                placeholderTextId={'WORKSPACE_DROPDOWN_PLACEHOLDER'}
                placeholderDefault={'Select...'}
                name={`${name}.position`}
                options={selectValues}
                component={BasicSelect}
            />
            <div className={'col-md-1'}>
                <VerbButton
                    buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                    fontAwesomeIcon={'fa-trash'}
                    onClick={() => removeField(i)}
                />
            </div>
        </div>
    ));

    return (
        <div className={'col-md-12'}>
            {fieldsToRender}
            <div className={cns('col-md-12')}>
                <VerbButton
                    onClick={pushField}
                    buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                    textId={'BUTTON_ADD_ANOTHER'}
                    defaultMessage={'Add another'}
                    fontAwesomeIcon={'fa-plus'}
                />
            </div>
        </div>
    );
};

UserInviteList.propTypes = {
    fields: PropTypes.object
};

export default UserInviteList;
